import { useRegisterSW } from 'virtual:pwa-register/react';
import { Button } from '@/components/ui';
import { RefreshCw, X } from 'lucide-react';

export function ReloadPrompt() {
    // 1. periodic sync check
    const intervalMS = 60 * 60 * 1000; // 1 hour

    const {
        offlineReady: [offlineReady, setOfflineReady],
        needRefresh: [needRefresh, setNeedRefresh],
        updateServiceWorker,
    } = useRegisterSW({
        onRegistered(r) {
            if (r) {
                setInterval(() => {
                    r.update();
                }, intervalMS);
            }
        },
        onRegisterError(error) {
            console.log('SW registration error', error);
        },
    });

    const close = () => {
        setOfflineReady(false);
        setNeedRefresh(false);
    };

    if (!offlineReady && !needRefresh) return null;

    return (
        <div className="fixed bottom-20 left-4 right-4 z-[100] md:left-auto md:right-8 md:bottom-8 md:w-96 animate-fade-in-up">
            <div className="bg-bg-elevated border border-gold-base/20 rounded-2xl p-4 shadow-2xl flex items-start gap-4">
                <div className="p-2 rounded-full bg-gold-base/10 text-gold-base shrink-0">
                    <RefreshCw className="w-5 h-5 animate-spin-slow" />
                </div>
                <div className="flex-1">
                    <h3 className="text-sm font-bold text-white mb-1">
                        {offlineReady ? 'Ready for Offline' : 'Update Available'}
                    </h3>
                    <p className="text-xs text-text-muted mb-3">
                        {offlineReady
                            ? 'App is cached and ready to use offline.'
                            : 'A new version is available. Reload to update.'}
                    </p>
                    <div className="flex gap-2">
                        {needRefresh && (
                            <Button
                                variant="primary"
                                size="sm"
                                onClick={() => updateServiceWorker(true)}
                                className="flex-1"
                            >
                                Reload
                            </Button>
                        )}
                        <Button
                            variant="ghost"
                            size="sm"
                            onClick={close}
                            className="flex-1"
                        >
                            Dismiss
                        </Button>
                    </div>
                </div>
                <button
                    onClick={close}
                    className="text-text-muted hover:text-white transition-colors"
                >
                    <X className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
}
